/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_TitleInputs */

const en_fw_pub_title = /** @type {(inputs: Fw_Pub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish as template`)
};

const id_fw_pub_title = /** @type {(inputs: Fw_Pub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan jadi template`)
};

/**
* | output |
* | --- |
* | "Publish as template" |
*
* @param {Fw_Pub_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_title = /** @type {((inputs?: Fw_Pub_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_title(inputs)
	return en_fw_pub_title(inputs)
});